import React from 'react';

export default () => <p>Terms of Service</p>